import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";

import "./separator.scss";

const messages = defineMessages({
  authSeparator: {
    id: "authSeparator",
    defaultMessage: "Or",
  },
});

export const Separator: FC = () => {
  const intl = useIntl();

  return (
    <div className="separator__container">
      <hr />
      <span>{intl.formatMessage(messages.authSeparator)}</span>
      <hr />
    </div>
  );
};
